/**
 * 콘텐츠 링크 제출 페이지 — 유의 사항 가이드 5 행.
 *
 * Figma 366:92959/92945/93002 의 GuideText × 5 (디자인 카피 반영).
 */
export const CONTENT_SUBMISSION_GUIDE = {
  title: '유의 사항',
  items: [
    '#광고 해시태그는 게시물 본문 최상단에 첫 번째로 작성해야 합니다.',
    '캠페인 상품이 명확하게 보이도록 촬영된 콘텐츠여야 합니다.',
    '필수 해시태그를 본문에 작성한 게시물이어야 합니다.',
    '콘텐츠 가이드를 준수한 게시물이어야 합니다.',
    '위의 모든 조건을 만족하며 유효한 게시물 링크만 인정됩니다.',
  ],
} as const;
